import { BREAKPOINT } from '@npco/zeller-design-system'

import { useImagePreloader } from 'hooks/useImagePreloader/useImagePreloader'
import { useIsMobileResolution } from 'hooks/useIsMobileResolution'

import { CorporateCardStartupModal } from './components/CorporateCardStartupModal/CorporateCardStartupModal'
import { getPreloadImages } from './CorporateCardStartup.utils'

export const CorporateCardStartup = () => {
  const isMobile = useIsMobileResolution()
  const isMobileOrTablet = useIsMobileResolution(BREAKPOINT.MD)

  const { imagesPreloaded } = useImagePreloader(
    getPreloadImages({ isMobile, isTablet: isMobileOrTablet && !isMobile })
  )

  return <>{imagesPreloaded && <CorporateCardStartupModal />}</>
}
